<template>
  <div>
    <div class="p-grid p-justify-center">
      <div class="p-col-4 p-text-left">
        <Button class="p-button-lg" @click="save" :label="$t('Button.save_and_finish')" />
      </div>
      <div class="p-col-4">
        <h1 class="title is-1">{{ $t("Bulk.edit") }}</h1>
      </div>
      <div class="p-col-4 p-text-right">
        <Button class="p-button-text p-button-danger" @click="cancel" :label="$t('Button.cancel_and_exit')" />
      </div>
      <div class="p-col-12">
        <div v-for="d in divisions" :key="d.id" class="entry" :style="{ borderColor: d.color }">
          <h1 class="title is-3 p-text-left">{{ $t("Division.header") }}: {{ d.name }}</h1>
          <table style="text-align: left">
            <tr>
              <th>{{ $t("Division.name") }}</th>
              <th>{{ $t("Division.abbr") }}</th>
              <th>{{ $t("Division.code") }}</th>
              <span v-if="!jpLocale" style="display: contents;">
                <th>{{ $t("Team.se_id") }}</th>
                <th>{{ $t("Team.mapping_code") }}</th>
              </span>
            </tr>
            <tr>
              <td><input v-model="d.name" /></td>
              <td><input v-model="d.shortcode" /></td>
              <td><input v-model="d.longcode" /></td>
              <span v-if="!jpLocale" style="display: contents;">
                <td><input v-model="d.se_id" /></td>
                <td><input v-model="d.se_mapping_code" /></td>
              </span>
            </tr>
          </table>

          <br /><br />
          <div v-if="d.teams.length">
            <h1 class="title is-6 p-text-left">{{ $t("Team.team_in") }} {{ d.name }}</h1>
            <table style="text-align: left">
              <tr>
                <th>{{ $t("Team.name") }}</th>
                <th>{{ $t("Team.abbr") }}</th>
                <th>{{ $t("Team.code") }}</th>
                <span v-if="!jpLocale" style="display: contents;">
                  <th>{{ $t("Team.se_id") }}</th>
                  <th>{{ $t("Team.mapping_code") }}</th>
                </span>
              </tr>
              <tr v-for="t in d.teams" :key="t.id">
                <td><input v-model="t.name" /></td>
                <td><input v-model="t.shortcode" /></td>
                <td><input v-model="t.longcode" /></td>
                <span v-if="!jpLocale" style="display: contents;">
                  <td><input v-model="t.se_id" /></td>
                  <td><input v-model="t.se_mapping_code" /></td>
                </span>
              </tr>
            </table>
          </div>
          <div v-else>{{ $t("Team.no_team") }}{{ d.name }}</div>
        </div>
        <br /><br />
        <div v-for="d in venues" :key="d.id" class="entry" :style="{ borderColor: d.color }">
          <h1 class="title is-3 p-text-left">{{ $t("Venue.venue") }}: {{ d.name }}</h1>
          <table style="text-align: left">
            <tr>
              <th>{{ $t("Venue.name") }}</th>
              <th>{{ $t("Venue.abbr") }}</th>
              <th>{{ $t("Venue.code") }}</th>
            </tr>
            <tr>
              <td><input v-model="d.name" /></td>
              <td><input v-model="d.shortcode" /></td>
              <td><input v-model="d.longcode" /></td>
            </tr>
          </table>

          <br /><br />
          <div v-if="d.surfaces.length">
            <h1 class="title is-6 p-text-left">{{ $t("Venue.playing_surface_at") }} {{ d.name }}</h1>
            <table style="text-align: left">
              <tr>
                <th>{{ $t("Surface.name") }}</th>
                <th>{{ $t("Surface.abbr") }}</th>
                <th>{{ $t("Surface.code") }}</th>
              </tr>
              <tr v-for="t in d.surfaces" :key="t.id">
                <td><input v-model="t.name" /></td>
                <td><input v-model="t.shortcode" /></td>
                <td><input v-model="t.longcode" /></td>
              </tr>
            </table>
          </div>
          <div v-else>{{ $t("Venue.no_surface") }} {{ d.name }}</div>
        </div>

        <br /><br />
        {{ activeItem }}
        <br /><br />
        {{ activeType }}
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      teams: [],
      divisions: [],
      venues: [],
      surfaces: [],
      activeItem: null,
      activeType: -1,
    };
  },
  methods: {
    cancel() {
      var x = window.confirm(this.$t("Bulk.prompt_confirm_cancel"));
      if (x) {
        this.refreshLeagueInformation("/");
      }
    },
    save() {
      var x = {
        id: this.currentSeason.id,
        divisions: this.divisions,
        venues: this.venues,
      };
      api
        .updateSeasonStuff(x)
        .then(response => {
          console.log("Success", response);
          this.makeToast("success", this.$t("Toast.change_saved"));
          this.refreshLeagueInformation("/");
        })
        .catch(e => {
          console.log("Error", e);
        });
    },
  },
  created() {},
  mounted() {
    this.teams = this.currentSeason.teams;
    this.divisions = this.currentSeason.divisions.map(division => {
      return {
        ...division,
        teams: division.teams.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        }),
      };
    });
    this.venues = this.currentSeason.venues;
    this.surfaces = this.currentSeason.surfaces;
  },
};
</script>

<style scoped lang="scss">
.entry {
  border-width: 1px;
  border-style: solid;
  border-radius: 10px;
  padding: 20px;
  margin: 20px auto;
}
table {
  width: 100%;
}

td,
td {
  text-align: left;
}
input {
  padding: 10px;
  width: 100%;
  border-color: rgba(0, 0, 0, 0.1);
}
</style>
